import { Box, Tooltip, Typography } from "@mui/material";
import { sidebarData } from "../../data/dashboard/sidebarData";
import { Link } from "react-router-dom";
import { useState } from "react";
import useCurrentPath from "../hooks/useCurrentPath";
import useResponsive from "../hooks/useResponsive";
import { InfoOutlined } from "@mui/icons-material";
import { COLORS } from "../../ui/Theme";
import {
  ListBox,
  ListDivider,
  ListItem,
  ListItemLabel,
  ListTitle,
} from "../../ui/ListStyles";

const Sidebar = ({ children }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const { isSm } = useResponsive();
  const { route1, route2 } = useCurrentPath();

  let timeoutId;

  const handleMouseEnter = (id) => {
    clearTimeout(timeoutId);
    setHoveredItem(id);
  };

  const handleMouseLeave = () => {
    timeoutId = setTimeout(() => setHoveredItem(null), 300);
  };

  // set for sidebar width , page width and right margin
  let dynamicWidth = !isSm ? 0 : "68px";

  return (
    <Box sx={{ display: "flex" }}>
      {isSm && (
        <Box
          sx={{
            position: "fixed",
            zIndex: 2,
            width: dynamicWidth,
            backgroundColor: COLORS.WHITE,
            height: "100vh",
            py: "20px",
            px: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {sidebarData.map((data) => (
            <Box
              key={data.id}
              onMouseEnter={() => handleMouseEnter(data.id)}
              onMouseLeave={handleMouseLeave}
              sx={{ position: "relative" }}
            >
              <Link to={data.link ? data.link : "#"}>
                <Typography
                  sx={{
                    background:
                      route1?.route === data.id
                        ? COLORS.SOFTBLUE
                        : COLORS.WHITE,
                    color:
                      route1?.route === data.id ? COLORS.BLUE : COLORS.GRAY,
                    py: "10px",
                    px: "12px",
                    borderRadius: 3,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    ":hover": {
                      backgroundColor: COLORS.SOFTGRAY,
                    },
                  }}
                >
                  {data.icon}
                </Typography>
              </Link>

              {hoveredItem === data.id && (
                <ListBox
                  className="dropdown"
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: "135%",
                  }}
                  onMouseEnter={() => clearTimeout(timeoutId)}
                  onMouseLeave={handleMouseLeave}
                >
                  {data.items ? (
                    <ListTitle>{data.title}</ListTitle>
                  ) : (
                    <Link to={data.link}>
                      <ListItem
                        sx={{
                          fontWeight: 900,
                          background:
                            route1.route === data.id &&
                            route2?.route === data.route &&
                            COLORS.SOFTBLUE,
                          color:
                            route1.route === data.id &&
                            route2?.route === data.route &&
                            COLORS.BLUE,
                        }}
                      >
                        {data.title}
                      </ListItem>
                    </Link>
                  )}

                  {data.items && (
                    <>
                      <ListDivider flexItem />

                      {data.items.map((item, i) => (
                        <Tooltip
                          key={i}
                          arrow
                          title={
                            item.desc && (
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: 0.5,
                                  flexWrap: "wrap",
                                  alignItems: "center",
                                }}
                              >
                                <Typography fontSize={"11px"}>
                                  {item?.desc}
                                </Typography>
                              </Box>
                            )
                          }
                          placement="left"
                        >
                          <Link to={item.link}>
                            <ListItem
                              sx={{
                                background:
                                  route1.route === data.id &&
                                  route2?.route === item.route &&
                                  COLORS.SOFTBLUE,
                                color:
                                  route1.route === data.id &&
                                  route2?.route === item.route &&
                                  COLORS.BLUE,
                              }}
                            >
                              <ListItemLabel>{item.label}</ListItemLabel>
                              {item.desc && <InfoOutlined fontSize="10px" />}
                            </ListItem>
                          </Link>
                        </Tooltip>
                      ))}
                    </>
                  )}
                </ListBox>
              )}
            </Box>
          ))}
        </Box>
      )}

      <Box
        sx={{
          width: isSm ? `calc(100vw - ${dynamicWidth})` : "100vw",
          p: { xs: 1, md: 3 },
          ml: dynamicWidth,
          mb: !isSm && "64px",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Sidebar;
